import Note from '@/designs-dev/annotations/Note';
import PreSignUp from '@/karehero-app/auth/PreSignUp';
import { PRE_SIGN_UP } from '@/karehero-app/auth/PreSignUp.content';
import { type HandoverSpec } from '@/designs-dev/handover/types';

const noop = () => {};

// The chat with one question asked and answered.
const asked = (id: string) => (
  <PreSignUp
    onCreateAccount={noop}
    onSignIn={noop}
    animate={false}
    option='chat'
    initialSlide={1}
    initialAsked={[id]}
  />
);

// Everything before the app asks for anything. Create account hands over to
// Sign up next door.
export const preSignUpSpec: HandoverSpec = {
  id: 'pre-sign-up',
  title: 'Pre-sign-up',
  description: '',
  links: [],
  flows: [
    {
      // Hello, then the chat. Two screens, and the chat is where the answers
      // are, so the button stops saying Get started and says what it does.
      title: 'Option one: chat style intro',
      noteAfter: (
        <Note title='Readme' variant='body2'>
          A list of one is not a choice, so when a single question is left the
          chat asks it itself. The last answer lands, and Create account is what
          remains.
        </Note>
      ),
      steps: [
        {
          id: 'two-welcome',
          title: PRE_SIGN_UP.slides[0].title,
          tap: 'Open the app',
          render: () => (
            <PreSignUp
              onCreateAccount={noop}
              onSignIn={noop}
              animate={false}
              option='chat'
            />
          ),
        },
        {
          id: 'two-ask',
          title: PRE_SIGN_UP.chat.question,
          tap: 'Tap ‘Get started’',
          render: () => (
            <PreSignUp
              onCreateAccount={noop}
              onSignIn={noop}
              animate={false}
              option='chat'
              initialSlide={1}
            />
          ),
        },
        {
          // One step, and the other two answers as alts under it. They are
          // three takes on the same screen rather than three screens: as steps
          // they read as a conversation repeating itself, because every one of
          // them was the same screen with the question swapped.
          id: 'two-answered',
          title: 'It answers, and asks again',
          tap: '‘What is KareHero?’',
          render: () => asked('what'),
          alt: [
            {
              title: '‘Who are your care experts?’',
              render: () => asked('expert'),
            },
            {
              title: '‘Can you help me check what I am entitled to?’',
              render: () => asked('entitled'),
            },
          ],
        },
      ],
    },
    {
      // Four slides that say what KareHero is, then in.
      title: 'Option two: traditional carousel',
      steps: PRE_SIGN_UP.slides.map((slide, i) => ({
        id: slide.id,
        title: slide.title,
        tap: i === 0 ? 'Open the app' : 'Tap ‘Get started’',
        render: () => (
          <PreSignUp
            onCreateAccount={noop}
            onSignIn={noop}
            option='carousel'
            initialSlide={i}
          />
        ),
      })),
    },
  ],
  states: [],
  components: {},
};
